// Validation utility functions

export const validateSubscription = (form) => {
  const errors = {};

  if (!form.name || form.name.trim() === "") {
    errors.name = "Subscription name is required";
  }

  if (!form.billingCycle || form.billingCycle === "") {
    errors.billingCycle = "Billing cycle is required";
  }

  if (!form.cost || form.cost === "" || Number(form.cost) <= 0) {
    errors.cost = "Valid cost is required";
  }

  if (!form.dueDate || form.dueDate === "") {
    errors.dueDate = "Due date is required";
  } else {
    const dueDate = new Date(form.dueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate < today) {
      errors.dueDate = "Due date cannot be in the past";
    }
  }

  // Owners: at least one required
  const owners = form.owners || [];
  const hasValidOwner = Array.isArray(owners) && owners.some(o => o?.email);
  if (!hasValidOwner) {
    errors.owners = "At least one owner is required";
  }

  // Payment details (only validate when a paymentType is selected)
  if (form.paymentType && form.paymentType.trim() !== "") {
    const details = form.paymentDetails || {};

    if (form.paymentType === "Credit Card" || form.paymentType === "Debit Card") {
      if (!details.cardHolderName) {
        errors.paymentDetails = "Card holder name is required for card payments";
      } else if (!details.cardLast4 || String(details.cardLast4).trim().length !== 4) {
        errors.paymentDetails = "Last 4 digits are required for card payments";
      }
    }

    if (form.paymentType === "Net Banking") {
      if (!details.accountHolderName) {
        errors.paymentDetails = "Account holder name is required for net banking";
      } else if (!details.bankName) {
        errors.paymentDetails = "Bank name is required for net banking";
      }
    }

    if (form.paymentType === "UPI") {
      if (!details.upiId) {
        errors.paymentDetails = "UPI ID is required for UPI payments";
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const validateAsset = (form) => {
  const errors = {};

  if (!form.name || form.name.trim() === "") {
    errors.name = "Asset name is required";
  }

  if (!form.type || form.type.trim() === "") {
    errors.type = "Asset type is required";
  }

  if (form.warrantyEnd) {
    const warrantyEnd = new Date(form.warrantyEnd);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (warrantyEnd < today) {
      errors.warrantyEnd = "Warranty end date cannot be in the past";
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const validateRenewal = (form) => {
  const errors = {};

  if (!form.newCost || form.newCost === "" || Number(form.newCost) <= 0) {
    errors.newCost = "Valid cost is required";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const validateWarrantyExtension = (form) => {
  const errors = {};

  if (!form.months || form.months === "" || Number(form.months) <= 0) {
    errors.months = "Valid number of months is required";
  }

  if (form.cost && Number(form.cost) < 0) {
    errors.cost = "Cost cannot be negative";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

